{
  "name": "termhub-ui",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "bash build-version.sh && ng serve",
    "build": "bash build-version.sh && ng build --configuration development",
    "build:prod": "bash build-version.sh && ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "predev": "bash build-version.sh",
    "test": "ng test --watch=false",
    "test:watch": "ng test --watch",
    "dev": "ng serve --port 4200 --host 0.0.0.0",
    "lint": "ng lint",
    "eslint": "eslint . --ext .ts",
    "prettier-format": "run-script-os",
    "prepare": "husky install",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "e2e": "ng e2e",
    "audit-scan": "npm audit --audit-level=high",
    "run-audit": "npm run audit-scan && npm start && npm dev"
  },
  "engines": {
    "node": "^20.20.2",
    "npm": ">=10.8.2"
  },
  "husky": {
    "hooks": {
      "pre-commit": "npm run prettier-format && npm run lint"
    }
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.32",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.32",
    "@angular/compiler": "^20.3.32",
    "@angular/core": "^20.3.32",
    "@angular/forms": "^20.3.32",
    "@angular/localize": "^20.3.32",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.32",
    "@angular/platform-browser-dynamic": "^20.3.32",
    "@angular/router": "^20.3.32",
    "@auth0/angular-jwt": "^5.1.2",
    "@cypress/schematic": "^4.1.1",
    "@eslint/plugin-kit": "^0.3.3",
    "@ng-bootstrap/ng-bootstrap": "^19.0.0",
    "angular-split": "^17.1.1",
    "bootstrap": "^5.2.3",
    "default-gateway": "^7.2.2",
    "execa": "^9.5.1",
    "foreground-child": "^3.3.0",
    "husky": "^8.0.3",
    "lodash": "^4.18.1",
    "ngx-file-drop": "^16.0.0",
    "ngx-toastr": "^19.0.0",
    "ngx-ui-loader": "^13.0.0",
    "node": "^20.20.2",
    "run-script-os": "^1.1.6",
    "rxjs": "^7.8.1",
    "tslib": "^2.7.0",
    "typescript": "^5.7.3",
    "uuid": "^14.0.0",
    "vite": "^8.0.16",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^20.0.0",
    "@angular-eslint/eslint-plugin": "^20.0.0",
    "@angular-eslint/eslint-plugin-template": "^20.0.0",
    "@angular-eslint/schematics": "^20.0.0",
    "@angular-eslint/template-parser": "^20.0.0",
    "@angular/build": "^20.3.40",
    "@angular/cli": "^20.3.32",
    "@angular/compiler-cli": "^20.3.32",
    "@types/node": "^22.5.5",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "cypress": "^15.21.0",
    "esbuild": "^0.28.1",
    "eslint": "^9.31.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-jest": "^28.8.3",
    "eslint-plugin-prettier": "^5.2.1",
    "jsdom": "^26.1.0",
    "prettier": "^3.3.3",
    "vitest": "^4.1.12"
  },
  "overrides": {
    "qs": "^6.16.0",
    "picomatch": "^4.0.4",
    "minimatch": "^10.2.4",
    "jsdom": "^26.1.0",
    "glob": "^13.0.6",
    "rimraf": "^5.0.10",
    "uuid": "^14.0.0",
    "webpack-dev-server": "^5.2.6",
    "@hono/node-server": "^2.0.6",
    "postcss": "^8.5.18",
    "brace-expansion": "^5.0.9",
    "@tootallnate/once": "^3.0.1",
    "webpack-dev-middleware": "7.4.6",
    "body-parser": "^2.4.0",
    "@angular/build": {
      "vitest": "^4.1.12",
      "vite": "^8.0.16",
      "esbuild": "^0.28.1",
      "piscina": "^5.2.0"
    },
    "@angular/cli": {
      "@modelcontextprotocol/sdk": "1.32.0"
    },
    "@cypress/request": {
      "uuid": "^14.0.0"
    },
    "sockjs": {
      "uuid": "^14.0.0"
    },
    "vite": {
      "esbuild": "^0.28.1"
    },
    "launch-editor": {
      "shell-quote": "^1.9.0"
    }
  },
  "optionalDependencies": {
    "@rollup/rollup-darwin-arm64": "4.59.0",
    "@rollup/rollup-darwin-x64": "4.59.0",
    "@rollup/rollup-linux-x64-gnu": "4.59.0",
    "@rollup/rollup-linux-x64-musl": "4.59.0"
  }
}
